import styled from 'styled-components';
import { LocalStorageKey } from '../data/client_local_storage.ts';
import { useLocalStorage } from '../data/use_local_storage.tsx';

export function LogMessages({ error }: { error?: string }) {
  const [logMessages] = useLocalStorage(LocalStorageKey.Logging);
  return (
    <ScrollContainer>
      {[...[...(error ? [error] : []), ...logMessages].entries()].map(([index, message]) => {
        return <Message key={index}>{message}</Message>;
      })}
    </ScrollContainer>
  );
}

const ScrollContainer = styled.div`
  height: 50vh;
  width: calc(min(100vw, 500px));
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: start;
  justify-items: start;
  background-color: var(--color-background);
`;

const Message = styled.div`
  text-align: left;
  color: var(--color-text);
`;
